import { GridSortModel } from '@mui/x-data-grid-premium';

export const MAX_SORT_COLUMNS = 5;

export type SortOrder = 'ascending' | 'descending';

export interface SortRequestItem {
  sortColumn: string;
  sortOrder: SortOrder;
}

/**
 * The generated `src/api` contracts predate the backend's multi-sort support and
 * have no `sorts` field. Intersect a request type with this until the swagger
 * spec is regenerated.
 */
export type WithSorts<T> = T & { sorts?: SortRequestItem[] };

export interface BuildSortRequestOptions {
  mapColumn?: (field: string) => string;
  defaultColumn?: string;
  defaultOrder?: SortOrder;
}

export interface SortRequestFields {
  sorts?: SortRequestItem[];
  sortColumn?: string;
  sortOrder?: SortOrder;
}

const toSortOrder = (direction: 'asc' | 'desc'): SortOrder =>
  direction === 'desc' ? 'descending' : 'ascending';

export const buildSortRequest = (
  sortModel: GridSortModel | undefined,
  { mapColumn, defaultColumn, defaultOrder = 'ascending' }: BuildSortRequestOptions = {},
): SortRequestFields => {
  const sorts = (sortModel ?? [])
    .filter((item): item is { field: string; sort: 'asc' | 'desc' } => Boolean(item.sort))
    .slice(0, MAX_SORT_COLUMNS)
    .map((item) => ({
      sortColumn: mapColumn ? mapColumn(item.field) : item.field,
      sortOrder: toSortOrder(item.sort),
    }));

  if (sorts.length === 0) {
    return defaultColumn
      ? {
          sortColumn: mapColumn ? mapColumn(defaultColumn) : defaultColumn,
          sortOrder: defaultOrder,
        }
      : {};
  }

  return { sorts, sortColumn: sorts[0].sortColumn, sortOrder: sorts[0].sortOrder };
};
